import createHistory from "history/createBrowserHistory";

let history = {};

if (typeof window === `object`) {
  history = createHistory();
  window.routerHistory = history;
}

export default history;
